<template>
    <div class="card position-relative" :style="`background: url(${data.image}) center no-repeat; background-size: cover;`">
        <!-- <a :href="data.link ? data.link : 'javascript:void(0)'"> -->
            <!-- <img :src="data.image" class="card-img" :alt="data.name"> -->
            <div class="card-img-overlay">
                <h5 class="card-title">{{ data.name }}</h5>
                <p class="card-text">{{ data.info }}</p>
                <p class="card-text"><small>{{ data.date }}</small></p>
            </div>
        <!-- </a> -->
    </div>
</template>


<script>
export default {
    name: "OverlayC",
    props:{
        data: {
            type: Object
        },
    },
    setup() {
        return {
        };
    },
}
</script>


<style lang="scss" scoped>
.card{
    position: relative;
}
.card:hover{
    // box-shadow: 0px 0px 20px #beb204 !important;

    transform: scale(1.01);
    box-shadow: 0 5px 20px rgba(255, 0, 0, 0.5);
    border-color: rgba(255, 215, 0, 0.8);
}
.card-img-overlay{
    position: absolute;
    top: auto;
    // bottom: 0px;
    height: 55px;
    // padding: 5px;
    background-color: rgba(var(--site-primary-color-rgb), .6);
    color: #ffffff;
    text-align: center;
    vertical-align: middle;
    border-radius: 10px;
}
</style>
